import React from 'react';
import {useAllFormsQuery} from 'api';
import useCondition from '../../useCondition';

export default () => {
  const {condition} = useCondition();
  const {data: {allForms = []} = {}} = useAllFormsQuery({
    fetchPolicy: 'cache-and-network',
  });

  if (!condition?.forms || !condition.forms.length) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2 last-of-type:border-none">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">フォーム</h4>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {allForms
          .filter((form) => condition.forms.includes(form.id))
          .map((form) => (
            <span
              key={form.id}
              className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {form.title}
            </span>
          ))}
      </div>
    </div>
  );
};
